<template>
    <div class="dmgm-third-part">
        <div v-if="show404" class="dmgm-portal-404">
            <div class="dmgm-portal-404-wrap">
                <h1>403</h1>
                <div class="dmgm-portal-404-wrap-des">登录不合法，请重新进入</div>
            </div>
        </div>
        <selectMainPage :visible="mainPage.visible" :options="mainPage.options" @close="closeSelectMainPageModal"
            @selected="selectedMainPage">
        </selectMainPage>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, reactive } from "vue";
import { useRouter } from 'vue-router'
import selectMainPage from './selectMainPage.vue';
import {
    checkThirdPartToken,
} from "@/api/account";
import {
    setToken,
    // setHeadPic,
    setUserInfo,
    setUserAuthority,
    setTenantInfo,
    getEntry,
    setEntry,
    setSysLib,
    // deleteFastLogin
} from "@/utils/author.js";
import {
    getSysLib
} from "@/api/system";
import {
    getTenantInfo
} from '@/api/tenant'
import {
    // loginByUsername,
    getUserInfo,
} from "@/api/user";
const mainPage = reactive({
    visible: false,
    options: []
})
const show404 = ref(false)

const router = useRouter()
// const state = reactive({
//     sysInfo: {},
//     sysVersion: {}
// })
// let userInfo = {}
let userAuthority = {}

const closeSelectMainPageModal = () => {
    mainPage.visible = false
    mainPage.options = []
}
const selectedMainPage = (_mainPage) => {
    setUserAuthority(userAuthority);
    getSysLib().then(sysLibResult => {
        if (sysLibResult.code === 200) {
            setSysLib(sysLibResult.data)
        }
    })

    getTenantInfo({
        tenantId: userAuthority.tenantId
    }).then((tenantInfo) => {
        if (tenantInfo && tenantInfo.success) {
            setTenantInfo(tenantInfo.data)
            window.history.replaceState(null, "", _mainPage.pageUrl);
            window.history.go(0);
        }
    })
}
onMounted(async () => {
    const { code } = router.currentRoute.value?.query
    if(!code) {
        show404.value = true
        return
    }
    let entry = getEntry()
    const { client_id, ip, client_secret } = entry.query
    entry.query.code = code
    setEntry(entry)
    let res = await checkThirdPartToken({
        tpClientId: client_id,
        tpClientSecret: client_secret,
        tpCode: code,
        redirectUri: `http://${window.location.host}/thirdPart`,
        ip: ip
    })
    if(res.Code !== 200){
        show404.value = true
        return
    }else{
        setUserInfo(res.Data)
    }
    try {
        let _userInfoResult = await getUserInfo()
        if (_userInfoResult && _userInfoResult.success) {
            userAuthority = _userInfoResult.data
            let _roleName = userAuthority.roleName
            let _pageAuths = userAuthority.pageAuths
            if (['Administrator', 'AppAdministrator'].includes(
                _roleName) ||
                _pageAuths.length === 0) {
                await setUserAuthority(userAuthority);
                let tenantInfo = await getTenantInfo({
                    tenantId: userAuthority.tenantId
                })
                if (tenantInfo && tenantInfo.success) {
                    await setTenantInfo(tenantInfo.data)
                    router.push({
                        path: "/home"
                    });
                    window.themeManager.replaceTheme()
                    window.authManager.init()
                }
            } else if (!['Administrator', 'AppAdministrator']
                .includes(
                    _roleName) && _pageAuths.length ===
                1) {
                selectedMainPage(_pageAuths[0])
            } else {
                mainPage.options = _pageAuths
                mainPage.visible = true
            }
        } else {
            show404.value = true
        }
    }
    catch {
        show404.value = true
    }

});
onUnmounted(() => { })
</script>

<style lang="less">
.dmgm-third-part {
    height: 100%;
}

.dmgm-portal-404 {
    height: 100%;
    background-color: #f1f1f1;
    display: flex;
    justify-content: center;

    .dmgm-portal-404-wrap {
        padding: 50px;
        width: 600px;
        text-align: center;
    }

    h1 {
        position: relative;
        font-size: 60px;
        text-shadow: 0 1px 0 #fff;
    }

    .dmgm-portal-404-wrap {
        color: rgba(0, 0, 0, 0.5);
        font-size: 18px;
    }
}
</style>